import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import {Menu, X, Globe, Drone, ChevronRight, User, LogOut, LayoutDashboard} from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Navbar = () => {
  const { language, setLanguage, t } = useLanguage();
  const { user, isAuthenticated, signOut } = useAuth();
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleLang = () => {
    setLanguage(language === 'en' ? 'fr' : 'en');
  };

  return (
    <nav className="bg-slate-900/95 backdrop-blur-sm fixed w-full z-50 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0 flex items-center gap-2">
            <Drone className="h-8 w-8 text-sky-500" />
            <span className="text-white font-bold text-xl tracking-wider">IRON HAWK <span className="text-sky-500">GHANA</span></span>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/#home" className="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors">{t('nav.home')}</a>
              <a href="/#services" className="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors">{t('nav.services')}</a>
              <a href="/contact" className="text-gray-300 hover:text-white hover:bg-slate-800 px-3 py-2 rounded-md text-sm font-medium transition-colors">{t('footer.contact')}</a>
            </div>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <button 
              onClick={toggleLang}
              className="flex items-center gap-1 text-gray-300 hover:text-white transition-colors"
            >
              <Globe className="h-4 w-4" />
              <span className="uppercase font-medium">{language}</span>
            </button>

            {isAuthenticated ? (
              <div className="flex items-center gap-4">
                <a href={user?.userRole === 'ADMIN' ? '/admin' : '/dashboard'} className="text-gray-300 hover:text-white font-medium text-sm flex items-center gap-2">
                  <LayoutDashboard className="h-4 w-4" />
                  {user?.userRole === 'ADMIN' ? (language === 'en' ? 'Admin' : 'Admin') : (language === 'en' ? 'Dashboard' : 'Tableau de Bord')}
                </a>
                <div className="flex items-center gap-3 pl-4 border-l border-slate-700">
                  <div className="flex flex-col items-end">
                    <span className="text-white text-sm font-medium">{user?.userName || 'User'}</span>
                    <span className="text-xs text-sky-500">{user?.userRole === 'ADMIN' ? 'Admin' : (language === 'en' ? 'Client' : 'Client')}</span>
                  </div>
                  <button 
                    onClick={() => signOut()}
                    className="bg-slate-800 hover:bg-slate-700 text-gray-300 p-2 rounded-full transition-colors"
                    title="Sign Out"
                  >
                    <LogOut className="h-4 w-4" />
                  </button>
                </div>
              </div>
            ) : (
              <a href="/login" className="bg-sky-600 hover:bg-sky-500 text-white px-4 py-2 rounded-full text-sm font-medium transition-all shadow-lg shadow-sky-900/20">
                {t('nav.login')}
              </a>
            )}
          </div>

          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-slate-800 focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-slate-900 border-b border-slate-800">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a href="/#home" className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium">{t('nav.home')}</a>
            <a href="/#services" className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium">{t('nav.services')}</a>
            <a href="/contact" className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium">{t('footer.contact')}</a>
            <button onClick={toggleLang} className="text-gray-300 hover:text-white w-full text-left px-3 py-2 rounded-md text-base font-medium flex items-center gap-2">
              <Globe className="h-4 w-4" /> {language === 'en' ? 'Français' : 'English'}
            </button>
            
            {isAuthenticated ? (
              <>
                <a href={user?.userRole === 'ADMIN' ? '/admin' : '/dashboard'} className="text-gray-300 hover:text-white block px-3 py-2 rounded-md text-base font-medium">{user?.userRole === 'ADMIN' ? 'Admin' : (language === 'en' ? 'Dashboard' : 'Tableau de Bord')}</a>
                <button onClick={() => signOut()} className="text-red-400 hover:text-red-300 w-full text-left px-3 py-2 rounded-md text-base font-medium flex items-center gap-2">
                  <LogOut className="h-4 w-4" /> Sign Out
                </button>
              </>
            ) : (
              <a href="/login" className="bg-sky-600 text-white block px-3 py-2 rounded-md text-base font-medium mt-4 text-center">
                {t('nav.login')}
              </a>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
